/** Store-scoped keys: switching stores never shares cache. */
export const policyKeys = {
  all: (storeId: string) => ['stores', storeId, 'policies'] as const,
  list: (storeId: string) => [...policyKeys.all(storeId), 'list'] as const,
  detail: (storeId: string, id: string) => [...policyKeys.all(storeId), 'detail', id] as const,
};
